import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { DatePicker, Select, Colors } from 'advenio-components'
import { Form } from 'formsy-react-2'

var Container = styled(Form)`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
`

var FilterItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 160px;
`

var ClearButton = styled.span`
  font-size: 13px;
  color: ${Colors.blue500};
  cursor: pointer;
  align-self: center;
  margin-top: 20px;
  &:hover {
    text-decoration: underline;
  }
`

var TYPE_OPTIONS = [
  { id: '0', label: 'Todos' },
  { id: 'application/pdf', label: 'PDF' },
  { id: 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document', label: 'Word' },
  { id: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', label: 'Excel' },
  { id: 'application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation', label: 'PowerPoint' },
  { id: 'image/jpeg,image/png', label: 'Imagen' },
  { id: 'text/plain', label: 'Texto' }
]

class DocumentFilters extends Component {
  constructor (props) {
    super(props)
    this.state = {
      type: '',
      dateFrom: null,
      dateTo: null
    }
  }

  handleTypeChange = (e) => {
    // Select component passes {target: {value}} where value is the label
    var selectedLabel = e && e.target ? e.target.value : ''
    // Find the option by label to get the id (which has the mime type)
    var selectedOption = null
    for (var i = 0; i < TYPE_OPTIONS.length; i++) {
      if (TYPE_OPTIONS[i].label === selectedLabel) {
        selectedOption = TYPE_OPTIONS[i]
        break
      }
    }
    var value = selectedOption ? selectedOption.id : ''
    if (value === '0') value = ''
    this.setState({ type: value }, this.emitFilters)
  }

  handleFormChange = (model) => {
    this.setState({
      dateFrom: model.date_from || null,
      dateTo: model.date_to || null
    }, this.emitFilters)
  }

  emitFilters = () => {
    var filters = {}
    if (this.state.type) {
      filters.type = this.state.type
    }
    if (this.state.dateFrom) {
      filters.dateFrom = this.state.dateFrom
    }
    if (this.state.dateTo) {
      filters.dateTo = this.state.dateTo
    }
    this.props.onFilterChange(filters)
  }

  clearFilters = () => {
    this.setState({ type: '', dateFrom: null, dateTo: null }, function () {
      this.props.onFilterChange({})
    }.bind(this))
  }

  render () {
    var hasFilters = this.state.type || this.state.dateFrom || this.state.dateTo

    return (
      <Container onChange={this.handleFormChange}>
        <FilterItem>
          <Select
            name='type'
            label='Tipo de archivo'
            options={TYPE_OPTIONS}
            onChangeCallback={this.handleTypeChange}
          />
        </FilterItem>
        <DatePicker
          name='date_from'
          label='Fecha inicio'
        />
        <DatePicker
          name='date_to'
          label='Fecha fin'
        />
      </Container>
    )
  }
}

DocumentFilters.propTypes = {
  onFilterChange: PropTypes.func.isRequired
}

export default DocumentFilters



// WEBPACK FOOTER //
// ./src/Components/Documents/DocumentFilters/index.jsx